import {
  createCalculationEngine,
  type CalculationEngineDependencies,
  type EstimatorInput,
  type EstimatorResult
} from "@reno-estimator/core";
import type { EstimatorClient } from "./types.js";

/**
 * Reference EstimatorClient that runs the engine in-process. Useful for
 * local dev, tests, and any non-WordPress host. The WordPress integration
 * package provides a REST-backed EstimatorClient instead - the
 * EstimatorController above doesn't know or care which one it's given.
 */
export function createInProcessEstimatorClient(deps: CalculationEngineDependencies): EstimatorClient {
  const engine = createCalculationEngine();
  return {
    async submit(input: EstimatorInput): Promise<EstimatorResult> {
      return engine.calculate(input, deps);
    }
  };
}
